import i18n from '@/locale/i18n'
import solution from '@/page/solution/index'

export default [
  {
    path: '/solution',
    component: solution,
    meta: { title: i18n.t('question.question1') }
  }]


// WEBPACK FOOTER //
// ./src/router/solution/index.js